<app-preloader *ngIf="showPreloader"></app-preloader>
<app-page-transition></app-page-transition>
<app-navbar *ngIf="showNavbar"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="showFooter"></app-footer>
<app-notification></app-notification>